<section class="ut-dash-card" aria-labelledby="dashboardActivityTitle">
  <h2 class="ut-dash-card__heading" id="dashboardActivityTitle">My Activity</h2>

  <div class="tabset">
    <!-- When the tabs don't fit, this select replaces them, so only one of the two controls is ever exposed. -->
    <div class="tabset__picker">
      <label for="dashboardActivityView">Show</label>
      <select id="dashboardActivityView" [value]="tab" (change)="onPick($any($event.target).value)">
        @for (t of tabs; track t.id) {
          <option [value]="t.id" [selected]="t.id === tab">{{ t.label }}@if (count(t.id) !== undefined) { ({{ count(t.id) }})}</option>
        }
      </select>
    </div>

    <div class="tabset__tabs" role="tablist" aria-labelledby="dashboardActivityTitle" (keydown)="onTabKeydown($event)">
      @for (t of tabs; track t.id) {
        <button
          type="button"
          role="tab"
          class="tabset__tab"
          [class.is-active]="t.id === tab"
          [id]="tabId(t.id)"
          [attr.aria-selected]="t.id === tab"
          [attr.aria-controls]="panelId(t.id)"
          [attr.tabindex]="t.id === tab ? 0 : -1"
          (click)="select(t.id)">
          {{ t.label }}
          @if (count(t.id) !== undefined) {
            <span class="tabset__count">{{ count(t.id) }}</span>
          }
        </button>
      }
    </div>
  </div>

  @for (t of tabs; track t.id) {
    <div
      class="tabset__panel"
      role="tabpanel"
      [id]="panelId(t.id)"
      [attr.aria-labelledby]="tabId(t.id)"
      [hidden]="t.id !== tab">
      @if (t.id === tab) {
        @switch (t.id) {
          @case ('all') {
            <ng-container *ngTemplateOutlet="feed; context: { $implicit: activities, label: 'All activity', empty: 'recent activity' }"></ng-container>
          }
          @case ('community') {
            <ng-container *ngTemplateOutlet="feed; context: { $implicit: community, label: 'Community activity', empty: 'community activity' }"></ng-container>
          }
          @case ('projects') {
            <ng-container *ngTemplateOutlet="projectList; context: { $implicit: projects, total: projectsCount, kind: 'project', label: 'Projects', noun: 'project', empty: 'active or pending projects' }"></ng-container>
          }
          @case ('invitations') {
            <ng-container *ngTemplateOutlet="projectList; context: { $implicit: invitations, total: invitationsCount, kind: 'invitation', label: 'Invitations', noun: 'invitation', empty: 'current invitations' }"></ng-container>
          }
        }
      }
    </div>
  }
</section>

<ng-template #feed let-views let-label="label" let-empty="empty">
  @if (views === undefined) {
    <p class="tabset__loading" role="status">Loading activity…</p>
  } @else if (views.length) {
    <ul class="ut-dash-activity" [attr.aria-label]="label">
      @for (view of views; track $index) {
        <li class="ut-dash-activity__item"><ut-activity-item [view]="view"></ut-activity-item></li>
      }
    </ul>
    <a class="ut-dash-card__footer" uiSref="activity">View all activity</a>
  } @else {
    <div class="ut-dash-empty">
      <p class="ut-dash-empty__title">You don't have any {{ empty }}.</p>
      <p class="ut-dash-empty__text">Check out the community page to share content and meet other uTesters.</p>
      <a class="ut-btn" uiSref="community">Community Page</a>
    </div>
  }
</ng-template>

<ng-template #projectList let-items let-total="total" let-kind="kind" let-label="label" let-noun="noun" let-empty="empty">
  @if (items === undefined) {
    <p class="tabset__loading" role="status">Loading {{ label.toLowerCase() }}…</p>
  } @else if (items.length) {
    <ul class="ut-dash-projects" [attr.aria-label]="label">
      @for (item of items; track $index) {
        <li><ut-dashboard-project-row [item]="item" [kind]="kind" [testerAppUrl]="testerAppUrl"></ut-dashboard-project-row></li>
      }
    </ul>
    @if (total > limit) {
      <a class="ut-dash-projects__more" [href]="testerAppUrl">
        <span class="ut-dash-projects__more-count">
          <i class="material-icons" aria-hidden="true">more_horiz</i>
          (+{{ total - limit }} more {{ noun }}{{ total - limit === 1 ? '' : 's' }})
        </span>
        <span class="ut-dash-projects__more-link">View All {{ label }}</span>
      </a>
    }
  } @else {
    <div class="ut-dash-empty">
      <p class="ut-dash-empty__title">You don't have any {{ empty }}.</p>
      <p class="ut-dash-empty__text">Browse the Projects Board to find new testing opportunities.</p>
      <a class="ut-btn" uiSref="project">Projects Board</a>
    </div>
  }
</ng-template>
